const appConfig = {
    APIURL: 'https://api.sar24.com/',
    apiPrefix: '/',
    authenticatedEntryPath: '/home',
    selectProject: '/select-project',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '',
    locale: 'en',
    enableMock: false,
}

export default appConfig
